import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import Box from '@atlaskit/primitives/box';
import { xcss } from '@atlaskit/primitives/xcss';
import Flex from '@atlaskit/primitives/components/flex';
import Stack from '@atlaskit/primitives/stack';

import { SidePanelHeader, SidePanelBody } from '@confluence/side-panel';

const titleSkeleton = xcss({
	height: '16px',
	width: '100%',
	borderRadius: 'radius.full',
});

const subHeaderSkeletion = xcss({
	height: '14px',
	borderRadius: 'radius.full',
	width: '60px',
	marginBottom: 'space.150',
});

const versionItemSkeleton = xcss({
	width: '75%',
	borderRadius: 'radius.full',
});

const sectionBodySkeleton = xcss({
	width: '100%',
	paddingBlock: 'space.250',
});

export const VersionHistoryLoadingPlaceholder = () => {
	return (
		<Box data-testId="version-history-placeholder">
			<SidePanelHeader>
				<Flex alignItems="center">
					<Box xcss={titleSkeleton} backgroundColor="color.skeleton" />
				</Flex>
			</SidePanelHeader>
			<SidePanelBody>
				<Stack xcss={sectionBodySkeleton}>
					<Box
						xcss={subHeaderSkeletion}
						paddingBlock="space.100"
						paddingInline="space.200"
						backgroundColor="color.skeleton"
					/>
					<Box
						xcss={versionItemSkeleton}
						paddingBlock="space.100"
						backgroundColor="color.skeleton"
					/>
				</Stack>
				<Stack xcss={sectionBodySkeleton}>
					<Box
						xcss={subHeaderSkeletion}
						paddingBlock="space.100"
						paddingInline="space.200"
						backgroundColor="color.skeleton"
					/>
					<Box
						xcss={versionItemSkeleton}
						paddingBlock="space.100"
						paddingInline="space.200"
						backgroundColor="color.skeleton"
					/>
				</Stack>
			</SidePanelBody>
		</Box>
	);
};
